// import { homeworkMock } from '~/components/pages/lesson/Homework/homeworkMock'

// for dev
const staging = 'staging18'

const state = () => ({
  homework: null, // TODO NULL
  lesson: null,
  lessonQuestions: null,
  homeworkQuestions: null,
  userAvatar: '',
  isHomeworkDataLoading: true
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  },
  addComment(state, comment) {
    if(state.lesson) {
      state.lesson.comments = { ...state.lesson.comments, [comment.id]: comment }
    }
  },

  setComplaint(state, id) {
    if(state.lesson) {
      state.lesson.comments[id].canComplaint = false
    }
  },

  updateCommentText(state, { id, text }) {
    if(state.lesson) {
      state.lesson.comments[id].text = text || state.lesson.comments[id].text
    }
  },

  toggleLike(state, { id, count, isLiked }) {
    if(state.lesson && id) {
      state.lesson.comments[id].likes = count ?? state.lesson.comments[id].likes
      state.lesson.comments[id].isLiked = isLiked ?? state.lesson.comments[id].isLiked
    }
  }
}

const actions = {
  async getHomework({ commit }, id) {
    const path = this.$config.isProd ?  'https://gb.ru' :`https://${staging}.staging.gb.ru`

    try {
      const { data } = await this.$axios.get(`${path}/api/v2/homework`, {
        params: {
          lesson_id: id
        }
      })

      await commit('set', {
        type: 'userAvatar',
        payload: data.userAvatar || ''
      })
      // auto Deadline extend if extension deadline date is before today
      if (data.extensionCount === 0 &&
        this.$moment(data.deadlineDate)
          .add(data.numberOfDaysToExtend, 'days')
          .isBefore(this.$moment()) &&
        (!data?.loadedHomework || data?.loadedHomework?.score <= 2)) {
        this.dispatch('lessons/extendDeadline', id)
      } else {
        await commit('set', {
          type: 'homework',
          payload: data
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      commit('set', {
        type: 'isHomeworkDataLoading',
        payload: false
      })
    }
  },

  async uploadHomework({ commit }, formData) {
    const path = this.$config.isProd ?  'https://gb.ru' :`https://${staging}.staging.gb.ru`

    try {
      const { data } = await this.$axios.post(`${path}/api/v2/homeworks`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

      await commit('set', {
        type: 'homework',
        payload: data
      })
      this.$notifications.addSuccess('ДЗ успешно загружено')
    } catch (e) {
      this.$notifications.addDanger('Ошибка при загрузке ДЗ')
      console.error(e)
    }
  },

  async updateHomeworkComment(_store, [id, comment]) {
      const path = this.$config.isProd ?  'https://gb.ru' :`https://${staging}.staging.gb.ru`

    try {
      await this.$axios.post(`${path}/api/v2/homeworks/user_comment`, { lesson_id: +id, user_comment: comment })

      this.$notifications.addSuccess('Комментарий успешно обновлен')
    } catch (e) {
      this.$notifications.addDanger('Ошибка при обновлении комментария')
      console.error(e)
    }
  },

  async extendDeadline({ commit }, id) {
      const path = this.$config.isProd ?  'https://gb.ru' :`https://${staging}.staging.gb.ru`

    try {
      const { data } = await this.$axios.post(`${path}/api/v2/homeworks/extend_deadline`, { lesson_id: id })

      await commit('set', {
        type: 'homework',
        payload: data
      })
      this.$notifications.addSuccess('Дедлайн успешно продлен')
    } catch (e) {
      this.$notifications.addDanger('Ошибка при продлении дедлайна')
      console.error(e)
    }
  },

  downloadFileLink(_store, file) {
    const fileName = file.filename || 'file'
    fetch(file.url)
      .then((response) => response.blob())
      .then((blob) => {
        if (navigator?.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(blob)
        }

        this.$notifications.addSuccess('Файл успешно загружен')
      })
      .catch((error) => {
        this.$notifications.addDanger('Ошибка при загрузке файла')
        console.error('Error loading file:', error)
      })
  }
}

export { state, mutations, actions }
